/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Success_TextInputs */



/**
* | output |
* | --- |
* | "Project import successful." |
*
* @param {Iframe_Remote_Success_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_success_text = /** @type {((inputs?: Iframe_Remote_Success_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Success_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importation du projet reussie.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projektimport erfolgreich.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione del progetto riuscita.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт проекта пройден успешно.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importación del proyecto exitosa.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("项目导入成功。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトのインポートに成功しました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट का आयात सफलतापूर्वक हो गया है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importação do projeto concluída com sucesso.")
	return /** @type {LocalizedString} */ ("Project import successful.")
});